<template>
  <div>
    <modulo-gerenciador-arquivo :path="item.pasta" :item="item" />
  </div>
</template>
<script>
export default {
  props: ["item"],
  data() {
    return {};
  },
  methods: {},
};
</script>
